var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOfficeStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 363.858,
    height: 329,
    viewBox: "0 0 363.858 329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(-647.897 -494)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 164.5,
    cy: 164.5,
    r: 164.5,
    transform: "translate(668 494)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(1461.606 150.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182",
    "data-name": "Group 182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M-652.148,472.3l.626-14.526,15.275-4.973,2.78,18.442,1.32,9.563-21,4.711Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_184",
    "data-name": "Group 184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_183",
    "data-name": "Group 183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M-697.222,530.842s-1.5-31.8,14.524-45.325a52.35,52.35,0,0,1,30.55-12.646s1.026,8.662,7.318,8.85,10.706-5.447,11.364-9.861c0,0,22.637,4.266,36.535,21.8,9.014,11.519,8.388,20.534,9.014,33.8l-23.413,3.386,4.006,43.321-63.73,8.89-2.379-53.213Z",
    fill: "#043aaa"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    y1: 19.897,
    x2: 1.531,
    transform: "translate(-672.76 505.311)",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M-658.032,435.434a26.632,26.632,0,0,0-1.377,11.019c.626,5.759,3.38,16.9,6.26,18.4s10.768,4.507,18.53-14.712S-653.274,410.518-658.032,435.434Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M-637.3,448.069v.137a2.53,2.53,0,0,0,2.542,2.575h.02l.9-1.992a23.374,23.374,0,0,0,1.175-2.8c1.46-3.789,2.587-5.334,2.6-8.319.033-7.9-4.628-7.411-4.628-7.411a4.5,4.5,0,0,0-.179-.7c-3.242-12.511-12.786-11.717-19.485-9.105a15.042,15.042,0,0,0-2.718,1.219c-.652.333-1.251.668-1.778.986-5.875,3.551-8.351,2.051-8.351,2.051.392,1.193,2.375,2,2.375,2-3.476-.015-3.862-2.5-3.862-2.5-1.608,4.562,2.436,8.957,4.628,9.255a8.21,8.21,0,0,1-3.873-.016s6.314,10.156,27.14,2.245a11.228,11.228,0,0,0,3.522,6.612l-.029,5.353",
    fill: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_187",
    "data-name": "Group 187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M-697.179,524.948l24.522.234-.491,7.307-24.4,1.6Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_190",
    "data-name": "Group 190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_189",
    "data-name": "Group 189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M-615.212,527.456s-1.056-12.192-2.182-18.952",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_196",
    "data-name": "Group 196"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_193",
    "data-name": "Group 193"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_192",
    "data-name": "Group 192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_191",
    "data-name": "Group 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M-450.091,593.346l-.071,2-.126,2.805H-492.07l-292.939.006L-813.6,556.785l.008-1.712.013-2.789,28.842,41.2Z",
    fill: "#f6f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    "data-name": "Group 195"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_194",
    "data-name": "Group 194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M-784.746,593.487l-28.861-41.2h3.99l32.763,0,27.316,0,270.721.021,28.725,41.029Z",
    fill: "#f6f7f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Table-2",
    "data-name": "Table"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_199",
    "data-name": "Group 199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_198",
    "data-name": "Group 198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_197",
    "data-name": "Group 197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M-813.583,552.283l28.842,41.2,334.649-.139",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M-567.254,598.149l-217.755.006L-813.6,556.785",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_201",
    "data-name": "Group 201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_200",
    "data-name": "Group 200"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M-760.952,593.477l-23.793.01-28.861-41.2",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M-464.4,572.906l14.311,20.44-222.113.094",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M-776.854,552.294l27.316,0,267.733.021",
    fill: "#f6f7f7",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "laptop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_204",
    "data-name": "Group 204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_203",
    "data-name": "Group 203"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_202",
    "data-name": "Group 202"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M-645.408,578.208l-26.826-4.269,2.333,14.42,10.179-2.121Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_207",
    "data-name": "Group 207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_206",
    "data-name": "Group 206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_205",
    "data-name": "Group 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M-664.445,586.049s15.538-6.7,18.082-7.656,2.863,2.014,0,3.393a194.916,194.916,0,0,1-20.425,7.959C-670.714,589.55-664.445,586.049-664.445,586.049Z",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Chracter_hand",
    "data-name": "Chracter hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_211",
    "data-name": "Group 211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_210",
    "data-name": "Group 210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_209",
    "data-name": "Group 209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_208",
    "data-name": "Group 208"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M-587.973,526.771l-27.239.685s-.751,11.148-3.13,12.651-34.056,17.4-38.063,19.783-13.146,1.252-17.9,6.886c-1.773,1.773-1.895,6.793-1.786,9.874a4.3,4.3,0,0,0,2.285,3.646l6.462,3.417a2.517,2.517,0,0,0,3.282-.843,8.363,8.363,0,0,1,5.032-3.573c4.883-1.252,11.018-7.669,12.4-9.391,2.358-2.775,29.673-6.511,36.059-8.514s18.593-3.694,21.348-11.832C-587.009,542.987-587.973,526.771-587.973,526.771Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Laptop-2",
    "data-name": "Laptop"
  }, /*#__PURE__*/React.createElement("g", {
    id: "laptop_2",
    "data-name": "laptop 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_212",
    "data-name": "Group 212"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M-667.472,589.762l-72.273-4.454a5.162,5.162,0,0,1-4.811-4.562l-5.78-50.214a2.76,2.76,0,0,1,2.819-3.075l73.772,2.068a4.157,4.157,0,0,1,4.019,3.741l5.333,53.3A2.914,2.914,0,0,1-667.472,589.762Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 5.663,
    cy: 5.816,
    rx: 5.663,
    ry: 5.816,
    transform: "translate(-713.012 552.604)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "iMac"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_216",
    "data-name": "Group 216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_215",
    "data-name": "Group 215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_214",
    "data-name": "Group 214"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M-554.847,572.276l-20.079,2.12a.014.014,0,0,0,0,.027l8.356,2.151h0l11.714.583a.012.012,0,0,0,.014-.011l.81-4.423a.015.015,0,0,0-.007-.015l-.8-.431Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_219",
    "data-name": "Group 219"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_218",
    "data-name": "Group 218"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M-527.15,557.239l-76.744,4.733a1.805,1.805,0,0,1-1.913-1.9l3.62-68.16a3.358,3.358,0,0,1,3.366-3.18l75.222.3a4,4,0,0,1,3.975,4.227l-3.432,59.863A4.369,4.369,0,0,1-527.15,557.239Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_222",
    "data-name": "Group 222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_221",
    "data-name": "Group 221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_220",
    "data-name": "Group 220"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M-525.723,557.239l-76.744,4.733a1.805,1.805,0,0,1-1.913-1.9l3.619-68.16a3.358,3.358,0,0,1,3.367-3.18l75.221.3a4,4,0,0,1,3.976,4.227l-3.432,59.863A4.37,4.37,0,0,1-525.723,557.239Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_227",
    "data-name": "Group 227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_224",
    "data-name": "Group 224"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M-560.863,526.384a.17.17,0,0,0-.13.275,6.7,6.7,0,0,1,.93,2.938c.47,3.005,4.79,42.825,4.79,42.825a42.512,42.512,0,0,1-2.442,5.728s18.877-1.22,20.473-1.5,4.79-1.221,3.006-8.734-12.773-42.168-12.773-42.168Z",
    fill: "#ededed"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_226",
    "data-name": "Group 226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_225",
    "data-name": "Group 225"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M-537.049,557.939c-3.848-12.917-9.96-32.193-9.96-32.193",
    fill: "none",
    stroke: "#5e5e5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_230",
    "data-name": "Group 230"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_228",
    "data-name": "Group 228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M-574.952,574.428l-.049.874s16.384,3.215,17.6,2.828,3.285-.857,2.346-9.918-4.6-38.4-4.695-39.062a4.289,4.289,0,0,0-1.071-2.6l-.307.164a5.88,5.88,0,0,1,.688,1.694c.171.815,3.894,35.77,4.4,43.623a7.146,7.146,0,0,1-.693,3.592c-.356.73-.828,1.368-1.392,1.368C-559.437,576.995-574.952,574.428-574.952,574.428Z",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_233",
    "data-name": "Group 233"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_232",
    "data-name": "Group 232"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_231",
    "data-name": "Group 231"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 3.005,
    cy: 4.129,
    rx: 3.005,
    ry: 4.129,
    transform: "translate(-548.88 555.388)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_244",
    "data-name": "Group 244"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_237",
    "data-name": "Group 237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_236",
    "data-name": "Group 236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_235",
    "data-name": "Group 235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_234",
    "data-name": "Group 234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M-468.711,485.835l-.935,2.524a2.425,2.425,0,0,1-.664.09,2.466,2.466,0,0,1-1.368-.412l.644-1.559-1.308-2.112-18.675-30.26-1.438-2.333,1.177-1.528,1.549,2.433,19.439,30.662Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_239",
    "data-name": "Group 239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_238",
    "data-name": "Group 238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M-495.9,456.565h0a1.969,1.969,0,0,1-.14-2.781l3.407-3.767a1.969,1.969,0,0,1,2.781-.14h0a1.97,1.97,0,0,1,.14,2.782l-3.406,3.766A1.969,1.969,0,0,1-495.9,456.565Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_243",
    "data-name": "Group 243"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_242",
    "data-name": "Group 242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M-467.756,485.895a2.559,2.559,0,0,1-1.89,2.464,2.425,2.425,0,0,1-.664.09,2.466,2.466,0,0,1-1.368-.412,2.514,2.514,0,0,1-1.186-2.142,2.473,2.473,0,0,1,.522-1.529,2.522,2.522,0,0,1,2.032-1.026h.02A2.561,2.561,0,0,1-467.756,485.895Z",
    fill: "#ededed"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_246",
    "data-name": "Group 246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_245",
    "data-name": "Group 245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M-469.646,488.359-487.2,535.634a12.765,12.765,0,0,0-.583,3.59v30.245h-4.083V539.224a10.165,10.165,0,0,1,.834-3.992l19.359-47.2",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M-480.447,574.694h-19.419a5.54,5.54,0,0,1,1.619-3.912,5.477,5.477,0,0,1,3.9-1.619h8.367A5.527,5.527,0,0,1-480.447,574.694Z",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_261",
    "data-name": "Group 261"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_253",
    "data-name": "Group 253"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M-494.942,485.552c-.1.091-.207.183-.313.267l-.022.019c-.1.09-.2.174-.3.256-2.89,1.961-11.087-3.145-18.592-11.655s-11.548-17.281-9.241-19.9c.094-.092.191-.182.292-.271l.022-.019c.1-.1.2-.186.3-.277a21.056,21.056,0,0,1,29.719,1.864A21.054,21.054,0,0,1-494.942,485.552Z",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_257",
    "data-name": "Group 257"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_256",
    "data-name": "Group 256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_255",
    "data-name": "Group 255"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_348",
    "data-name": "Path 348",
    d: "M-495.255,485.821l-.021.017c-.033.035-.066.065-.1.1a1.617,1.617,0,0,1-.208.16c-2.887,1.961-11.087-3.142-18.59-11.655s-11.549-17.278-9.244-19.9a2.193,2.193,0,0,1,.187-.187.663.663,0,0,1,.108-.085l.022-.021c1.983-1.475,6.645.606,11.864,4.94a62.209,62.209,0,0,1,6.8,6.662,65.986,65.986,0,0,1,4.706,5.993C-495.319,478.231-493.385,483.876-495.255,485.821Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_260",
    "data-name": "Group 260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_259",
    "data-name": "Group 259"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_258",
    "data-name": "Group 258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_349",
    "data-name": "Path 349",
    d: "M-499.725,471.84a8.6,8.6,0,0,1-5.691,1.3,8.679,8.679,0,0,1-7.592-9.643,8.665,8.665,0,0,1,1.772-4.314,62.209,62.209,0,0,1,6.8,6.662A65.986,65.986,0,0,1-499.725,471.84Z",
    fill: "#fff",
    stroke: "#5e5e5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfficeStart);
export default __webpack_public_path__ + "static/media/office-start.e3101c82a60915de9dd7087a51042910.svg";
export { ForwardRef as ReactComponent };